import { cn } from '../../lib/utils';

export const STATUS_LABEL = {
  draft: 'Draft',
  pending: 'In review',
  approved: 'Published',
  rejected: 'Changes requested',
};

const STATUS_CLASS = {
  draft: 'bg-[#EFEBE3] text-[#5C574D]',
  pending: 'bg-[#E8F0FE] text-[#1A4FB0]',
  approved: 'bg-[#E3F4E8] text-[#1F6B3A]',
  rejected: 'bg-[#FFF0E0] text-[#A15A00]',
  hidden: 'bg-[#EFEBE3] text-[#5C574D]',
};

/** Review status of a partner template; a published one that is hidden from the catalog shows "Hidden". */
export const StatusPill = ({ status, live, className }) => {
  const hidden = status === 'approved' && live === false;
  const key = hidden ? 'hidden' : status;
  return (
    <span className={cn('shrink-0 rounded-full px-2.5 py-1 text-[11px] font-extrabold', STATUS_CLASS[key] || STATUS_CLASS.draft, className)}>
      {hidden ? 'Hidden' : STATUS_LABEL[status] || status}
    </span>
  );
};

export const money = (v) => `$${Number(v || 0).toFixed(2)}`;
